import { render } from "./InAppPurchaseEditorCmp.vue?vue&type=template&id=8d4f9d6a"
import script from "./InAppPurchaseEditorCmp.vue?vue&type=script&lang=js"
export * from "./InAppPurchaseEditorCmp.vue?vue&type=script&lang=js"

import "./InAppPurchaseEditorCmp.vue?vue&type=style&index=0&id=8d4f9d6a&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__